export const CATEGORY_LABELS = {
  samfund: "Samfund",
  politik: "Politik",
  udland: "Udland",
  business: "Business",
  tech: "Tech",
  krimi: "Krimi",
  sport: "Sport",
  nyheder: "Nyheder",
  debat: "Debat",
  erhverv: "Erhverv",
  kultur: "Kultur",
  penge: "Penge",
  indland: "Indland",
  klima: "Klima",
  sundhed: "Sundhed",
  underholdning: "Underholdning",
  livsstil: "Livsstil",
  videnskab: "Videnskab",
  rejser: "Rejser",
  mad: "Mad",
  bolig: "Bolig",
  motor: "Motor",
  fodbold: "Fodbold",
  haandbold: "Håndbold",
  tennis: "Tennis",
  cykling: "Cykling",
  opinion: "Debat",
  leder: "Leder",
  navnenyt: "Nyheder",
};

